import { Button } from "@/components/ui/button";
import { Link2, Unlink } from "lucide-react";
import { fmtEur, fmtData, MEZZI, STATI, statoKey } from "@/lib/banche";

const Badge = ({ cfg, testid }) => <span className={`inline-block rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${cfg?.cls}`} data-testid={testid}>{cfg?.label}</span>;

export const MezzoSelect = ({ m, onMezzo }) => (
  <select value={m.mezzo} onChange={(e) => onMezzo(m, e.target.value)} className={`rounded-full px-2 py-0.5 text-[10px] font-semibold border-0 cursor-pointer ${MEZZI[m.mezzo]?.cls}`} data-testid={`mov-mezzo-${m.id}`}>
    {Object.entries(MEZZI).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
  </select>
);

const Collegamenti = ({ m }) => (m.collegamenti || []).length > 0 && (
  <div className="text-[11px] text-muted-foreground">
    {m.collegamenti.map((l) => `n. ${l.numero} (${fmtEur(l.importo)})`).join(", ")}
    {m.eccedenza > 0.005 && <span className="text-amber-700"> · eccedenza {fmtEur(m.eccedenza)}</span>}
  </div>
);

const Azione = ({ m, onCollega, onScollega }) => (m.collegamenti || []).length > 0
  ? <Button size="sm" variant="ghost" className="h-8" onClick={() => onScollega(m)} title="Annulla collegamento" data-testid={`mov-scollega-${m.id}`}><Unlink className="h-3.5 w-3.5" /></Button>
  : <Button size="sm" variant="outline" className="h-8" onClick={() => onCollega(m)} data-testid={`mov-collega-${m.id}`}><Link2 className="h-3.5 w-3.5 mr-1" />Collega</Button>;

export const MovimentoRiga = (p) => {
  const { m } = p;
  const imp = <span className={`font-bold tabular-nums ${m.importo > 0 ? "text-emerald-700" : "text-red-600"}`} data-testid={`mov-importo-${m.id}`}>{fmtEur(m.importo)}</span>;
  return (
    <tr className="border-t align-top" data-testid={`mov-row-${m.id}`}>
      <td className="px-3 py-2 whitespace-nowrap">{fmtData(m.data)}</td>
      <td className="px-3 py-2 text-xs">{m.banca}</td>
      <td className="px-3 py-2 max-w-[340px]"><div className="text-xs break-words line-clamp-2" title={m.descrizione}>{m.descrizione}</div><Collegamenti m={m} />{m.nota && <div className="text-[11px] italic text-muted-foreground">{m.nota}</div>}</td>
      <td className="px-3 py-2 text-xs">{m.controparte}</td>
      <td className="px-3 py-2"><MezzoSelect m={m} onMezzo={p.onMezzo} /></td>
      <td className="px-3 py-2 text-right">{imp}</td>
      <td className="px-3 py-2"><Badge cfg={STATI[statoKey(m)]} testid={`mov-stato-${m.id}`} /></td>
      <td className="px-3 py-2 text-right"><Azione {...p} /></td>
    </tr>
  );
};

export const MovimentoCard = (p) => {
  const { m } = p;
  return (
    <div className="rounded-lg border p-3 space-y-1.5" data-testid={`mov-card-${m.id}`}>
      <div className="flex justify-between items-start gap-2">
        <div className="text-xs text-muted-foreground">{fmtData(m.data)} · {m.banca}</div>
        <span className={`text-lg font-extrabold tabular-nums ${m.importo > 0 ? "text-emerald-700" : "text-red-600"}`}>{fmtEur(m.importo)}</span>
      </div>
      {m.controparte && <div className="text-sm font-semibold">{m.controparte}</div>}
      <div className="text-xs break-words line-clamp-3">{m.descrizione}</div>
      <Collegamenti m={m} />
      <div className="flex items-center justify-between gap-2 pt-1">
        <div className="flex gap-1 flex-wrap"><MezzoSelect m={m} onMezzo={p.onMezzo} /><Badge cfg={STATI[statoKey(m)]} /></div>
        <Azione {...p} />
      </div>
    </div>
  );
};
